import React, { useEffect } from "react";
import { Grid, IconButton, Tooltip } from "@material-ui/core";
import {
  BackButton,
  ButtonSubmit,
  Container,
  Panel,
  Regex,
} from "../../../../Components";
import { useStyles } from "./Customer.styles";
import {
  PasswordField,
  TextField2,
  NumberField,
  LanguageProps,
} from "../../../../Components/Field";
import { SelectDropDown } from "../../../../Components/Select/SelectDropDown";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import CustomerServicesApi from "../../../../Redux/Actions/CustomerAction";
import { useSnackbar } from "notistack";
import CopyIcon from "../../../../Assets/Images/copyIcon.png";
import { inputFieldProps } from "./FormProps";
import { Alert, AlertTitle } from "@mui/material";
import UserSevicesApi from "../../../../Redux/Actions/UserAction";
export const FormCustomer = () => {
  let { userList, apiToken, allCustomers, customerCreate, getCustomersById } =
    useSelector((state: any) => ({
      userList: state?.UserReducer?.userList,
      apiToken: state?.UserReducer?.apiToken,
      allCustomers: state?.CustomerReducer?.allCustomers,
      sendInvite: state?.CustomerReducer?.sendInvite,
      customerCreate: state?.CustomerReducer?.customerCreate,
      getCustomersById: state?.CustomerReducer?.getCustomersById,
    }));
  const regex = /^(0|[1-9][0-9]*)$/;
  const classes = useStyles();
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  let users = getCustomersById;
  let [input, setInput] = React.useState<inputFieldProps>({
    companyName: "",
    organisation_id: "",
    contactPerson: "",
    visitingAddress: "",
    city: "",
    postalCode: "",
    billingAddress: "",
    billingEmail: "",
    billingCity: "",
    billingPostal: "",
    bilingMobile: "",
    billingReference: "",
    firstName: "",
    lastName: "",
    email: "",
    language: "Svenska",
    ftp_Name: "",
    ftp_password: "",
  });
  let [userId, setUserId] = React.useState(
    userList == undefined ? [] : userList[0]?.id
  );
  const [coped, setCoped] = React.useState(false);
  const [hover, sethover] = React.useState(false);
  const dispatch: any = useDispatch();
  useEffect(() => {
    if (userList == undefined) {
      navigate("/");
    }
    dispatch(UserSevicesApi.UserListData(users?.id, apiToken, enqueueSnackbar));
  }, []);
  const createClient = async () => {
    if (!input?.companyName) {
      enqueueSnackbar(formatMessage({ id: "form.company.input" }), {
        variant: "error",
        content: input?.companyName,
      });
    } else if (!input?.organisation_id) {
      enqueueSnackbar(formatMessage({ id: "form.organization.input" }), {
        variant: "error",
        content: input?.organisation_id,
      });
    } else if (!input?.contactPerson) {
      enqueueSnackbar(formatMessage({ id: "form.contact.input" }), {
        variant: "error",
        content: input?.contactPerson,
      });
    } else if (!input?.visitingAddress) {
      enqueueSnackbar(formatMessage({ id: "form.address.input" }), {
        variant: "error",
        content: input?.visitingAddress,
      });
    } else if (!input?.city) {
      enqueueSnackbar(formatMessage({ id: "form.city.input" }), {
        variant: "error",
        content: input?.city,
      });
    } else if (!input?.postalCode) {
      enqueueSnackbar(formatMessage({ id: "form.postal.input" }), {
        variant: "error",
        content: input?.postalCode,
      });
    } else if (
      input?.postalCode?.toString()?.match(/^(0|[1-9][0-9]*)$/) == null
    ) {
      enqueueSnackbar(formatMessage({ id: "form.postalFormat.input" }), {
        variant: "error",
      });
    } else if (!input?.billingAddress) {
      enqueueSnackbar(formatMessage({ id: "form.address.input" }), {
        variant: "error",
        content: input?.billingAddress,
      });
    } else if (!input.billingEmail) {
      enqueueSnackbar(formatMessage({ id: "form.email.input" }), {
        variant: "error",
        content: "",
      });
    } else if (input?.billingEmail?.match(Regex) == null) {
      enqueueSnackbar(formatMessage({ id: "form.emailWrongFormat" }), {
        variant: "error",
        content: "",
      });
    } else if (!input?.billingCity) {
      enqueueSnackbar(formatMessage({ id: "form.city.input" }), {
        variant: "error",
        content: input?.billingCity,
      });
    } else if (!input?.billingPostal) {
      enqueueSnackbar(formatMessage({ id: "form.postal.input" }), {
        variant: "error",
        content: input?.billingPostal,
      });
    } else if (
      input?.billingPostal?.toString()?.match(/^(0|[1-9][0-9]*)$/) == null
    ) {
      enqueueSnackbar(formatMessage({ id: "form.postalFormat.input" }), {
        variant: "error",
      });
    } else if (!input?.billingReference) {
      enqueueSnackbar(formatMessage({ id: "form.contact.input" }), {
        variant: "error",
        content: input?.billingReference,
      });
    } else if (!input?.bilingMobile) {
      enqueueSnackbar(formatMessage({ id: "form.mobile.input" }), {
        variant: "error",
        content: input?.bilingMobile,
      });
    } else if (input.bilingMobile.toString().length !== 10) {
      enqueueSnackbar(formatMessage({ id: "form.mobilelength.input" }), {
        variant: "error",
      });
    } else if (!input?.ftp_Name) {
      enqueueSnackbar(formatMessage({ id: "customer.create.ftpUser" }), {
        variant: "error",
        content: input?.ftp_Name,
      });
    } else if (!input?.ftp_password) {
      enqueueSnackbar(formatMessage({ id: "customer.create.password" }), {
        variant: "error",
        content: input?.ftp_password,
      });
    } else if (!input?.firstName) {
      enqueueSnackbar(formatMessage({ id: "form.first.name.input" }), {
        variant: "error",
        content: input?.firstName,
      });
    } else if (!input?.lastName) {
      enqueueSnackbar(formatMessage({ id: "form.last.name.input" }), {
        variant: "error",
        content: input?.lastName,
      });
    } else if (input?.email.match(Regex) == null) {
      enqueueSnackbar(formatMessage({ id: "form.emailWrongFormat" }), {
        variant: "error",
        content: "",
      });
    } else if (!input?.language) {
      enqueueSnackbar(formatMessage({ id: "form.language.input" }), {
        variant: "error",
        content: input?.language,
      });
    } else {
      const createClientAdmin = {
        companyName: input?.companyName,
        organisationId: input?.organisation_id,
        contactPerson: input?.contactPerson,
        ftpUserName: input?.ftp_Name,
        ftpPassword: input?.ftp_password,
        ftpDirectory: "",
        addresses: [
          {
            customerId: 0,
            locationAddress: input?.visitingAddress,
            city: input?.city,
            postalCode: input?.postalCode.toString().replace(" ", ""),
            email: "",
            mobile: "",
            addressType: "CompanyAddress",
            referencePerson: "",
          },
          {
            customerId: 0,
            locationAddress: input?.billingAddress,
            city: input?.billingCity,
            postalCode: input?.billingPostal.toString().replace(" ", ""),
            email: input?.billingEmail,
            mobile: input?.bilingMobile,
            addressType: "BillingAddress",
            referencePerson: input?.billingReference,
          },
        ],
      };
      const invitation = {
        email: input?.email,
        firstName: input?.firstName,
        lastName: input?.lastName,
        language: LanguageProps[input?.language],
        roleId: 1, //inviting client admin
        sentBy: userId,
        customerId: 0,
      };
      const allcutstomer = allCustomers.filter((item: any) => {
        return item.email === input?.email;
      });
      if (!input?.email) {
        enqueueSnackbar(
          formatMessage({
            id: "component.message.fill",
            defaultMessage: "Please form fill all details",
          }),
          {
            variant: "error",
            content: input?.email,
          }
        );
      } else {
        if (allcutstomer?.length === 0) {
          dispatch(
            CustomerServicesApi.AddClientAdmin(
              createClientAdmin,
              invitation,
              apiToken,
              enqueueSnackbar
            )
          );
          setTimeout(() => {
            reloadform();
          }, 1000);
        }
      }
    }
  };
  const reloadform = () => {
    if (customerCreate?.companyName) {
      dispatch(CustomerServicesApi.customers(apiToken));
      navigate("/administration/customers");
    }
    // else {
    //   enqueueSnackbar(formatMessage({ id: 'customer.message.error', defaultMessage: "Client with this email already exists!" }), {
    //     variant: 'error',
    //     content: customerCreate?.content,
    //   });
    // }
  };
  const copyPassword = () => {
    navigator.clipboard.writeText(users?.ftpPassword);
    setCoped(true);
    const timeId = setTimeout(() => {
      setCoped(false);
    }, 2000);
    return () => {
      clearTimeout(timeId);
    };
  };
  const bodydata = [
    {
      title: formatMessage({
        id: "document.group.table.name",
        defaultMessage: "First name",
      }),
      field: "firstName",
    },
    {
      title: formatMessage({
        id: "users.table.email",
        defaultMessage: "Email",
      }),
      field: "email",
    },
    {
      title: formatMessage({ id: "users.table.role", defaultMessage: "Role" }),
      field: "role",
    },
  ];
  return (
    <Container fullWidth>
      <Grid container justifyContent="flex-start">
        <BackButton link={"/administration/customers"} />
      </Grid>
      <Panel titleKey={"form.add.customers"}>
        <Grid style={{ marginBottom: 10, fontSize: 16, fontWeight: "bold" }}>
          {formatMessage({
            id: "form.information",
            defaultMessage: "Information",
          })}
        </Grid>
        <div className="customer-form-container">
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, companyName: str })
                }
                placeholder={formatMessage({
                  id: "form.company.input",
                  defaultMessage: "Name",
                })}
                value={input?.companyName}
                Textlabel="form.company.name"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, organisation_id: str })
                }
                placeholder={formatMessage({
                  id: "form.organization.input",
                  defaultMessage: "Organisation Id",
                })}
                value={input?.organisation_id}
                Textlabel="form.organization.number"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, contactPerson: str })
                }
                placeholder={formatMessage({
                  id: "form.contact.input",
                  defaultMessage: "Contact person",
                })}
                value={input?.contactPerson}
                Textlabel="form.contact.person"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, visitingAddress: str })
                }
                placeholder={formatMessage({
                  id: "form.address.input",
                  defaultMessage: "Address",
                })}
                value={input?.visitingAddress}
                Textlabel="form.visiting.address"
              />
            </Grid>
            {/* </Grid>
        <Grid container spacing={3}> */}
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, postalCode: str })
                }
                placeholder={formatMessage({
                  id: "form.postal.input",
                  defaultMessage: "Postal code",
                })}
                value={input?.postalCode}
                Textlabel="form.postal.code"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) => setInput({ ...input, city: str })}
                placeholder={formatMessage({
                  id: "form.city.input",
                  defaultMessage: "City",
                })}
                value={input?.city}
                Textlabel="form.city"
              />
            </Grid>
          </Grid>
          <Grid style={{ marginTop: 15, fontSize: 16, fontWeight: "bold" }}>
            {formatMessage({ id: "form.billing", defaultMessage: "Billing" })}
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, billingAddress: str })
                }
                placeholder={formatMessage({
                  id: "form.address.input",
                  defaultMessage: "Billing address",
                })}
                value={input?.billingAddress}
                Textlabel="form.billing.address"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, billingEmail: str })
                }
                placeholder={formatMessage({
                  id: "form.email.input",
                  defaultMessage: "Billing email",
                })}
                value={input?.billingEmail}
                Textlabel="form.billing.email"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, billingPostal: str })
                }
                placeholder={formatMessage({
                  id: "form.postal.input",
                  defaultMessage: "Postal code",
                })}
                value={input?.billingPostal}
                Textlabel="form.postal.code"
              />
            </Grid>
            {/* </Grid>
        <Grid container spacing={3}> */}
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, billingCity: str })
                }
                placeholder={formatMessage({
                  id: "form.city.input",
                  defaultMessage: "City",
                })}
                value={input?.billingCity}
                Textlabel="form.city"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, billingReference: str })
                }
                placeholder={formatMessage({
                  id: "form.contact.input",
                  defaultMessage: "Reference person",
                })}
                value={input?.billingReference}
                Textlabel="form.reference.person"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                // name={input?.bilingMobile}
                onChange={(str: string) =>
                  {
                    if(str?.length<=10){
                      setInput({ ...input, bilingMobile: str })
                    }
                  }
                }
                placeholder={formatMessage({
                  id: "form.fillInPhoneNumber",
                  defaultMessage: "Mobile Number",
                })}
                value={input?.bilingMobile}
                Textlabel="customer.create.mobile"
              />
            </Grid>
          </Grid>
          {/*ftp details */}
          <Grid style={{ marginTop: 15, fontSize: 16, fontWeight: "bold" }}>
            {formatMessage({
              id: "admin.users.invite.ftp.customer",
              defaultMessage: "FTP Detail",
            })}
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, ftp_Name: str })
                }
                placeholder={formatMessage({
                  id: "customer.create.ftpUser",
                  defaultMessage: "FTP User",
                })}
                value={input?.ftp_Name}
              />
            </Grid>
            <Grid item xs={4} style={{ display: "flex", gap: "10px" }}>
              <PasswordField
                placeholder={formatMessage({
                  id: "customer.create.password",
                  defaultMessage: "FTP Password",
                })}
                handleChange={(str: string) =>
                  setInput({ ...input, ftp_password: str })
                }
                value={input?.ftp_password}
                Textlabel=""
                disabled={false}
              />
              {/* </Grid>
              <Grid item xs={1}> */}
              <Tooltip
                title={formatMessage({
                  id: "form.input.text.copy",
                  defaultMessage: "Copy",
                })}
                aria-label="add"
              >
                <IconButton
                  onClick={copyPassword}
                  className={classes.copyButton22}
                  onMouseOver={() => sethover(true)}
                  onMouseOut={() => sethover(false)}
                >
                  <img
                    src={CopyIcon}
                    alt="copyIcon"
                    className={classes.copyImage}
                  />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid>
              {coped ? (
                <Alert severity="success" className={classes.alertToast}>
                  <AlertTitle>
                    {formatMessage({
                      id: "customer.tost.copy",
                      defaultMessage: "Coped!",
                    })}
                  </AlertTitle>
                </Alert>
              ) : null}
            </Grid>
          </Grid>
          <Grid
            style={{
              marginTop: 15,
              marginBottom: 10,
              fontSize: 16,
              fontWeight: "bold",
            }}
          >
            {formatMessage({
              id: "form.clientAdmin",
              defaultMessage: "Client Admin",
            })}
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, firstName: str })
                }
                placeholder={formatMessage({
                  id: "form.fillInFirstName",
                  defaultMessage: " Enter first name",
                })}
                value={input?.firstName}
                Textlabel="customer.create.firstName"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, lastName: str })
                }
                placeholder={formatMessage({
                  id: "form.fillInLastName",
                  defaultMessage: " Enter last name",
                })}
                value={input?.lastName}
                Textlabel="customer.create.lastName"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) => setInput({ ...input, email: str })}
                placeholder={formatMessage({
                  id: "form.fillInEmail",
                  defaultMessage: " Enter email",
                })}
                value={input?.email}
                Textlabel="customer.create.email"
              />
            </Grid>
          </Grid>
          <Grid item xs={4}>
            <SelectDropDown
              placeholder={formatMessage({
                id: "form.language.input",
                defaultMessage: "Select Language",
              })}
              handleChange={(event) =>
                setInput({ ...input, language: event?.target?.value })
              }
              fieldName={"lang"}
              OptionsValue={["Svenska", "English"]}
              selected={input?.language}
              ClassName={`${classes.formControl} formcustomer-dropdown-input`}
              Textlabel="labal"
            />
          </Grid>
          <Grid
            container
            justifyContent="flex-end"
            className={classes.paddingRight40}
          >
            <ButtonSubmit text={"model.title.save"} onClick={createClient} />
          </Grid>
        </div>
      </Panel>
    </Container>
  );
};
